// 程序化像素美术:所有素材均由代码绘制,无外部版权资源
import { T } from "../../shared/types";

export const TILE = 32;

function cv(w: number, h: number) {
  const c = document.createElement("canvas");
  c.width = w; c.height = h;
  return c;
}

// 确定性伪随机(按坐标)
function hash(x: number, y: number, s = 0) {
  let h = x * 374761393 + y * 668265263 + s * 2147483647;
  h = (h ^ (h >> 13)) * 1274126177;
  return ((h ^ (h >> 16)) >>> 0) / 4294967296;
}

// ---------- 地块 ----------
const tileCache = new Map<string, HTMLCanvasElement>();

export function tileSprite(t: number, x: number, y: number): HTMLCanvasElement {
  // 静态 tile 按类型缓存;带噪点的按 (类型 + 位置低2位) 缓存变体
  const v = (x * 7 + y * 13) % 4;
  const key = `${t}:${v}`;
  const hit = tileCache.get(key);
  if (hit) return hit;
  const c = cv(TILE, TILE);
  const g = c.getContext("2d")!;
  drawTile(g, t, x, y);
  tileCache.set(key, c);
  return c;
}

function px(g: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, color: string) {
  g.fillStyle = color;
  g.fillRect(x, y, w, h);
}

function drawTile(g: CanvasRenderingContext2D, t: number, x: number, y: number) {
  const r = (s: number) => hash(x, y, s);
  switch (t) {
    case T.GRASS: {
      px(g, 0, 0, TILE, TILE, "#8fd35f");
      for (let i = 0; i < 5; i++) {
        const gx = Math.floor(r(i) * 28) + 2, gy = Math.floor(r(i + 9) * 28) + 2;
        px(g, gx, gy, 2, 3, r(i + 3) > 0.5 ? "#7cc24f" : "#a3e074");
      }
      break;
    }
    case T.PATH: {
      px(g, 0, 0, TILE, TILE, "#e3c98f");
      for (let i = 0; i < 4; i++) {
        px(g, Math.floor(r(i) * 26) + 3, Math.floor(r(i + 5) * 26) + 3, 3, 2, "#d4b87a");
      }
      break;
    }
    case T.WATER: {
      px(g, 0, 0, TILE, TILE, "#4db3e8");
      px(g, 4 + Math.floor(r(1) * 16), 8 + Math.floor(r(2) * 12), 10, 2, "#7fd0f5");
      px(g, 8 + Math.floor(r(3) * 14), 18 + Math.floor(r(4) * 8), 8, 2, "#7fd0f5");
      break;
    }
    case T.SAND: {
      px(g, 0, 0, TILE, TILE, "#f0dfa8");
      px(g, Math.floor(r(1) * 24) + 4, Math.floor(r(2) * 24) + 4, 2, 2, "#e0cc8c");
      break;
    }
    case T.TREE: {
      px(g, 0, 0, TILE, TILE, "#8fd35f");
      // 树干
      px(g, 13, 20, 6, 10, "#8b5e3c");
      // 树冠
      px(g, 5, 6, 22, 16, "#3d9142");
      px(g, 8, 3, 16, 6, "#4aa84f");
      px(g, 9, 8, 4, 4, "#67c46b");
      px(g, 19, 12, 3, 3, "#67c46b");
      break;
    }
    case T.FLOWER: {
      px(g, 0, 0, TILE, TILE, "#8fd35f");
      const colors = ["#ff8fb2", "#ffd166", "#c5a3ff", "#ff9f68"];
      for (let i = 0; i < 3; i++) {
        const fx = 5 + Math.floor(r(i) * 20), fy = 6 + Math.floor(r(i + 4) * 18);
        px(g, fx, fy + 3, 2, 5, "#4aa84f");
        px(g, fx - 1, fy, 4, 4, colors[Math.floor(r(i + 8) * 4)]);
        px(g, fx, fy + 1, 2, 2, "#fff3d6");
      }
      break;
    }
    case T.FARM: {
      px(g, 0, 0, TILE, TILE, "#b08954");
      px(g, 0, 6, TILE, 3, "#9a7648");
      px(g, 0, 16, TILE, 3, "#9a7648");
      px(g, 0, 26, TILE, 3, "#9a7648");
      break;
    }
    case T.CROPS: {
      px(g, 0, 0, TILE, TILE, "#b08954");
      px(g, 0, 26, TILE, 3, "#9a7648");
      for (let i = 0; i < 4; i++) {
        const fx = 4 + i * 7;
        px(g, fx, 12, 3, 12, "#e8b93e");
        px(g, fx - 1, 8, 5, 6, "#f5d76e");
      }
      break;
    }
    case T.STONE: {
      px(g, 0, 0, TILE, TILE, "#cfc8bd");
      g.strokeStyle = "#b8b0a3";
      g.lineWidth = 1;
      g.strokeRect(0.5, 0.5, 15, 15);
      g.strokeRect(16.5, 16.5, 15, 15);
      g.strokeRect(16.5, 0.5, 15, 15);
      g.strokeRect(0.5, 16.5, 15, 15);
      break;
    }
    case T.DOOR: {
      px(g, 0, 0, TILE, TILE, "#e3c98f");
      break;
    }
    case T.BENCH: {
      px(g, 0, 0, TILE, TILE, "#8fd35f");
      px(g, 4, 10, 24, 5, "#a0724a");
      px(g, 4, 17, 24, 5, "#a0724a");
      px(g, 6, 22, 3, 6, "#7c5736");
      px(g, 23, 22, 3, 6, "#7c5736");
      break;
    }
    case T.STUMP: {
      px(g, 0, 0, TILE, TILE, "#e0cc8c");
      px(g, 8, 10, 16, 14, "#a0724a");
      px(g, 10, 12, 12, 4, "#c49a6c");
      break;
    }
    case T.FOUNTAIN: {
      px(g, 0, 0, TILE, TILE, "#cfc8bd");
      px(g, 2, 2, 28, 28, "#9aa8b5");
      px(g, 5, 5, 22, 22, "#4db3e8");
      px(g, 12, 8, 8, 10, "#dff3ff");
      break;
    }
    case T.CAMPFIRE: {
      px(g, 0, 0, TILE, TILE, "#e0cc8c");
      px(g, 6, 20, 20, 5, "#7c5736");
      px(g, 10, 8, 12, 14, "#ff9f2e");
      px(g, 13, 5, 6, 12, "#ffd166");
      break;
    }
    default:
      px(g, 0, 0, TILE, TILE, "#8fd35f");
  }
}

// ---------- 建筑(整体绘制,非逐格) ----------
export function drawBuilding(
  g: CanvasRenderingContext2D,
  b: { x: number; y: number; w: number; h: number; color: string; name: string; emoji: string; open: boolean },
  homeStyle = false
) {
  if (b.open) return;
  const x = b.x * TILE, y = b.y * TILE, w = b.w * TILE, h = b.h * TILE;
  const roofH = Math.max(14, h * 0.42);

  // 墙体
  g.fillStyle = homeStyle ? "#f3e3c2" : "#f7ead0";
  g.fillRect(x, y + roofH, w, h - roofH);
  // 墙基
  g.fillStyle = "rgba(0,0,0,0.12)";
  g.fillRect(x, y + h - 5, w, 5);
  // 屋顶
  g.fillStyle = b.color;
  g.beginPath();
  g.moveTo(x - 5, y + roofH + 2);
  g.lineTo(x + w / 2, y - 4);
  g.lineTo(x + w + 5, y + roofH + 2);
  g.closePath();
  g.fill();
  g.fillStyle = "rgba(255,255,255,0.25)";
  g.beginPath();
  g.moveTo(x - 5, y + roofH + 2);
  g.lineTo(x + w / 2, y - 4);
  g.lineTo(x + w / 2, y + roofH + 2);
  g.closePath();
  g.fill();

  if (!homeStyle && w >= 6 * TILE) {
    // 窗户
    g.fillStyle = "#7ec8e3";
    const n = Math.floor(w / 70);
    for (let i = 0; i < n; i++) {
      const wx = x + 22 + i * ((w - 44) / Math.max(n - 1, 1));
      g.fillRect(wx - 8, y + roofH + 14, 16, 16);
      g.strokeStyle = "#8b5e3c";
      g.lineWidth = 2;
      g.strokeRect(wx - 8, y + roofH + 14, 16, 16);
    }
    // 招牌
    g.fillStyle = "#fff8e7";
    roundRect(g, x + w / 2 - 46, y + roofH - 4, 92, 20, 6);
    g.fill();
    g.strokeStyle = b.color;
    g.lineWidth = 2;
    roundRect(g, x + w / 2 - 46, y + roofH - 4, 92, 20, 6);
    g.stroke();
    g.fillStyle = "#5b4636";
    g.font = "12px sans-serif";
    g.textAlign = "center";
    g.fillText(`${b.emoji} ${b.name}`, x + w / 2, y + roofH + 10);
  }

  // 门
  const doorW = homeStyle ? 16 : 22;
  const dx = x + w / 2 - doorW / 2;
  g.fillStyle = "#8b5e3c";
  g.fillRect(dx, y + h - 26, doorW, 26);
  g.fillStyle = "#ffd166";
  g.fillRect(dx + doorW - 6, y + h - 14, 3, 3);
}

export function roundRect(g: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number) {
  g.beginPath();
  g.moveTo(x + r, y);
  g.arcTo(x + w, y, x + w, y + h, r);
  g.arcTo(x + w, y + h, x, y + h, r);
  g.arcTo(x, y + h, x, y, r);
  g.arcTo(x, y, x + w, y, r);
  g.closePath();
}

// ---------- 角色 ----------
const charCache = new Map<string, HTMLCanvasElement>();

export function charSprite(color: string, hat: string, frame: number): HTMLCanvasElement {
  const key = `${color}:${hat}:${frame}`;
  const hit = charCache.get(key);
  if (hit) return hit;
  const c = cv(32, 36);
  const g = c.getContext("2d")!;
  const bob = frame === 1 ? 1 : 0;

  // 影子
  g.fillStyle = "rgba(0,0,0,0.18)";
  g.beginPath();
  g.ellipse(16, 32, 9, 3.5, 0, 0, Math.PI * 2);
  g.fill();

  // 身体(圆滚滚小人)
  g.fillStyle = color;
  g.beginPath();
  g.ellipse(16, 21 + bob, 10, 11, 0, 0, Math.PI * 2);
  g.fill();
  g.fillStyle = "rgba(255,255,255,0.28)";
  g.beginPath();
  g.ellipse(13, 17 + bob, 4.5, 5.5, -0.4, 0, Math.PI * 2);
  g.fill();

  // 脸
  g.fillStyle = "#fff4e0";
  g.beginPath();
  g.ellipse(16, 16 + bob, 7.5, 6.5, 0, 0, Math.PI * 2);
  g.fill();
  // 眼睛
  g.fillStyle = "#3a2e28";
  g.fillRect(12.5, 14 + bob, 2, 3);
  g.fillRect(17.5, 14 + bob, 2, 3);
  // 腮红
  g.fillStyle = "rgba(255,120,120,0.5)";
  g.fillRect(10.5, 18 + bob, 2.5, 1.5);
  g.fillRect(19, 18 + bob, 2.5, 1.5);
  // 嘴
  g.fillStyle = "#3a2e28";
  g.fillRect(14.5, 19.5 + bob, 3, 1.2);

  // 脚(走路帧)
  g.fillStyle = shade(color, -30);
  const lo = frame === 1 ? 2 : 0;
  g.fillRect(10, 30 + bob - lo, 5, 3 + lo);
  g.fillRect(17, 30 + bob - (2 - lo), 5, 3 + (2 - lo));

  drawHat(g, hat, bob);

  charCache.set(key, c);
  return c;
}

function drawHat(g: CanvasRenderingContext2D, hat: string, bob: number) {
  switch (hat) {
    case "straw": // 草帽
      g.fillStyle = "#e8c96a";
      g.beginPath();
      g.ellipse(16, 11 + bob, 12, 4, 0, 0, Math.PI * 2);
      g.fill();
      g.fillRect(10, 5 + bob, 12, 6);
      g.fillStyle = "#c9a44a";
      g.fillRect(10, 9 + bob, 12, 2);
      break;
    case "beret": // 贝雷帽
      g.fillStyle = "#b03a5b";
      g.beginPath();
      g.ellipse(15, 9 + bob, 9, 4.5, -0.15, 0, Math.PI * 2);
      g.fill();
      g.fillRect(14, 3 + bob, 2, 3);
      break;
    case "cap": // 棒球帽
      g.fillStyle = "#e0435a";
      g.beginPath();
      g.ellipse(16, 9 + bob, 8, 4.5, 0, Math.PI, Math.PI * 2);
      g.fill();
      g.fillRect(16, 8 + bob, 11, 3);
      break;
    case "wizard": // 尖顶帽
      g.fillStyle = "#6d28d9";
      g.beginPath();
      g.moveTo(6, 10 + bob);
      g.lineTo(16, -3 + bob);
      g.lineTo(26, 10 + bob);
      g.closePath();
      g.fill();
      g.fillStyle = "#ffd166";
      g.fillRect(14, 3 + bob, 3, 3);
      break;
    case "flower": // 花环
      g.fillStyle = "#ff8fb2";
      for (const [fx, fy] of [[9, 9], [13, 7], [18, 7], [22, 9]]) {
        g.beginPath();
        g.arc(fx, fy + bob, 2.2, 0, Math.PI * 2);
        g.fill();
      }
      break;
    case "band": // 头巾
      g.fillStyle = "#ef7d1a";
      g.fillRect(8, 7 + bob, 16, 4);
      break;
    case "glasses": // 眼镜(不算帽子但叠加)
      g.strokeStyle = "#2d2a26";
      g.lineWidth = 1.5;
      g.strokeRect(10.5, 13 + bob, 5, 5);
      g.strokeRect(16.5, 13 + bob, 5, 5);
      g.beginPath();
      g.moveTo(15.5, 15 + bob);
      g.lineTo(16.5, 15 + bob);
      g.stroke();
      break;
    default:
      break;
  }
}

function shade(hex: string, amt: number) {
  const n = parseInt(hex.slice(1), 16);
  const r = Math.min(255, Math.max(0, (n >> 16) + amt));
  const g = Math.min(255, Math.max(0, ((n >> 8) & 0xff) + amt));
  const b = Math.min(255, Math.max(0, (n & 0xff) + amt));
  return `rgb(${r},${g},${b})`;
}
